import React, { useEffect, useState } from 'react';
import DashboardCard from "components/DashboardCard";
import Pets from '@mui/icons-material/Pets';
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import api from 'api';
import { Link } from 'react-router-dom';



const pageSize = 10;
const RecentPatients = ({ size }) => {
	const [ rows, setRows ] = useState([]);

	useEffect(() => {
		async function fetchPatients() {
			let result = await api.get('/patients/list', {
				params: {
					patient_name: '',
					client_name: '',
					patient_breed: '',
					last_visit_start: '',
					last_visit_end: '',
					page_size: pageSize,
					page_number: 0,
				},
			});

			setRows(result.data.patients);
		}

		fetchPatients().catch(err => console.log(err));

	}, [ setRows ]);

	return (<DashboardCard
		color="green"
		icon={<Pets />}
		topContent="Recently Added Patients"
		topLabel={`Showing the ${rows.length} most recent patients`}
		size={size}
	>
		<div>

			<Table sx={{ width: '100%' }} size="small">

				<TableHead>
					<TableRow>
						<TableCell align="left">Patient Name</TableCell>
						<TableCell align="left">Client Name</TableCell>
						<TableCell align="right">Date Added</TableCell>
					</TableRow>
				</TableHead>

				<TableBody>
					{rows.map((row, index) => (
						<TableRow key={index}>
							<TableCell component="th" scope="row">
								<Link to={`/patients/view/${row.patient_id}`}>{row.patient_name}</Link>
							</TableCell>
							<TableCell align="left">
								{row.client_name}
							</TableCell>
							<TableCell align="right">{row.date_created}</TableCell>
						</TableRow>
					))}
				</TableBody>

			</Table>

		</div>
	</DashboardCard>);
};



RecentPatients.defaultProps = {
	size: 'md',
};

RecentPatients.propTypes = {
	size: PropTypes.oneOf([ 'xs', 'sm', 'md', 'lg', 'xl' ]).isRequired,
};


export default RecentPatients;
